
















import { Component, Prop, Vue } from 'vue-property-decorator';
import { BaseGetter, FilterGetter, SearchGetter } from '@/store/getters';
import SupportedLayout from '@/types/SupportedLayout';
import { BaseAction } from '@/store/actions';
import TileTrackerHelper from '@/helpers/TileTrackerHelper';
import HtmlDataHelper from '@/helpers/HtmlDataHelper';
import DataLayerActionType from '@/types/DataLayerActionType';
import DataLayerClickTarget from '@/types/DataLayerClickTarget';

@Component({
  name: 'layout-switch-button-component',
})
export default class LayoutSwitchButtonComponent extends Vue {
  @Prop()
  private layout: SupportedLayout | undefined;

  private tileTracker = new TileTrackerHelper(new HtmlDataHelper());

  private get activeLayout(): SupportedLayout {
    return this.$store.getters[BaseGetter.ActiveLayout];
  }

  private get iClass(): string {
    return this.layout === SupportedLayout.LIST ? 'ux-icon--th-list-solid' : 'ux-icon--th-large-solid';
  }

  private get isLayoutSwitchVisible(): boolean {
    return this.$store.getters[BaseGetter.IsLayoutSwitchVisible];
  }

  private triggerSwitchLayout() {
    if (this.activeLayout !== this.layout) {
      this.$store.dispatch(BaseAction.SwitchActiveLayout, { layout: this.layout });

      this.tileTracker.sendGoogleDataLayer({
        searchTerm: this.$store.getters[SearchGetter.SearchTerm],
        country: this.$store.getters[BaseGetter.Country],
        searchContext: this.$store.getters[FilterGetter.ActiveSearchContext],
        actionType: DataLayerActionType.CLICK,
        hasResults: this.$store.getters[SearchGetter.TotalNumberOfResults] > 0,
        clickTarget: {
          type: DataLayerClickTarget.SWAP_LAYOUT,
          value: this.layout,
        },
        suggestion: this.$store.getters[SearchGetter.SearchSuggestions].term.length > 0
          ? this.$store.getters[SearchGetter.SearchSuggestions].term
          : DataLayerClickTarget.NONE,
      });
    }
  }

  // eslint-disable-next-line class-methods-use-this
  private canShowTooltipOnMobile(): boolean {
    return !(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
  }

  created() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      && this.activeLayout !== SupportedLayout.LIST
      && !sessionStorage.getItem('mobileDefaultLayout')
    ) {
      this.$store.dispatch(BaseAction.SwitchActiveLayout, { layout: SupportedLayout.LIST });
      // this.$store.dispatch(AnalyticsAction.ClickLayoutSwitcher, {
      //   layout: SupportedLayout.LIST,
      // });
      sessionStorage.setItem('mobileDefaultLayout', '1');
    }
  }
}
